import React from 'react'
import { Box, Flex, Heading, Icon, Text, VStack, Badge, HStack } from "@chakra-ui/react";
import { FaCheck } from "react-icons/fa";

export const SelectionCard = ({category, isSelected, onSelect}) => {
  return (
    <Box 
      p={6} 
      bg={isSelected ? "blue.100" : "white"}
      rounded="lg" 
      shadow="md"
      cursor="pointer" 
      transition="all 0.2s"
      _hover={{
        bg: "blue.100",
      }}
      borderColor={isSelected ? "blue.500" : "gray.200"}
      onClick={() => onSelect(category.id)}
    >
      <Flex justify="space-between" align="start">
        <VStack align="start" spacing={4} flex={1}>
          <HStack spacing={4}>
            <Box w={12} h={12} bg="blue.100" borderRadius="lg" display="flex" alignItems="center" justifyContent="center">
              <Icon as={category.icon} color="blue.500" boxSize={6} />
            </Box>
            <Heading as="h3" size="md" color="gray.900">{category.title}</Heading>
          </HStack>
          <Text color="gray.600" fontSize="sm">{category.description}</Text>
          <HStack spacing={2} wrap="wrap">
            {category?.tags?.map((tag) => (
              <Badge key={tag} colorScheme="gray" fontSize="0.7em" p="3px" borderRadius={5} padding="5px">{tag}</Badge>
            ))}
          </HStack>
        </VStack>
        <Box w={6} h={6} borderWidth={2} borderRadius="full" display="flex" alignItems="center" justifyContent="center" borderColor={isSelected ? "blue.500" : "gray.300"} bg={isSelected ? "blue.500" : "transparent"}>
          {isSelected && <Icon as={FaCheck} color="white" boxSize={3} />}
        </Box>
      </Flex>
    </Box>
  )
}
